import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a specific inquiry
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetInquiry = packet => {
  return {
    type: 'REQUEST_GET_INQUIRY',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetInquirySuccess = data => ({
  type: 'RECEIVE_GET_INQUIRY_SUCCESS',
  data
})

export const receiveGetInquiryFail = data => ({
  type: 'RECEIVE_GET_INQUIRY_FAIL',
  data
})

export const tryToGetInquiry = packet => (dispatch, getState) => {

  dispatch(requestGetInquiry(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/inquiries/' + packet.id, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetInquirySuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetInquiryFail({errors:e, lastSubmit: packet}));
    })
}
